<template>
	<div class="wearth" ref="ragRef">
		<div class="mid_left_table_nav">
			<table class="mid_left_table" v-if="isshow">
				<tr>
					<th>监测日期</th>
					<th>最低气温</th>
					<th>最高气温</th>
					<th>光照</th>
					<th>日雨量</th>
				</tr>
				<tr v-for="item in datapages">
					<td>{{ item?.record_day }}</td>
					<td>{{ item?.minValue_111}}℃</td>
					<td>{{ item?.maxValue_111}}℃</td>
					<td>{{ item?.avgValue_151}}Lux</td>
					<td>{{ item?.avgValue_222}}mm</td>
				</tr>
			</table>
			<div class="mid_left_table_not" v-if="!isshow">
				<div class="mid_left_table_not_img">
					<img src="@/assets/model/null.png" alt="" />
				</div>
				<p>暂无气象监测表数据</p>
			</div>

		</div>
		<div class="pagination">
			<pagination :initPageIndex="total" @changePage="handlePageChange" />
		</div>
	</div>
</template>

<script setup>
	import pagination from '../../pagination/index.vue';
	import {
		ElLoading
	} from 'element-plus'
	import {
		ref,
		onMounted,
		onUnmounted
	} from 'vue';
	import {
		GetEnvPage
	} from '@/api/api.js'

	let isshow = ref(true)

	const datapages = ref([])
	const total = ref(0)
	const currentDate = new Date();
	//定义div的ref
	let ragRef = ref()
	let ragRefInstance = ref()
	const page = {
		deviceAddr: "40266183",
		environmentIdList: [111, 151, 222],
		beginTime: new Date(currentDate.getFullYear(), 8, 10),
		endTime: new Date(currentDate.getFullYear(), 9, 31)
	}



	onMounted(() => {
		ragRefInstance.value = ElLoading.service({
			target: ragRef.value,
			body: true,
			text: 'Loading...',
		})
		GetEnvPage(1, page).then(res => {
			if (res.data.list.length == 0) {
				isshow.value = false
			} else {
				total.value = res.data.total
				for (let i = 0; i < res.data.list.length; i++) {
					datapages.value.push(res.data.list[i])
				}
			}
			ragRefInstance.value.close()
		}).catch(err => {
			console.log(err)
			ragRefInstance.value.close()
		})
	})

	function handlePageChange(pageindex) {
		ragRefInstance.value = ElLoading.service({
			target: ragRef.value,
			body: true,
			text: 'Loading...',
		})
		datapages.value = [];
		GetEnvPage(pageindex, page).then(res => {

			for (let i = 0; i < res.data.list.length; i++) {
				datapages.value.push(res.data.list[i])
			}

			ragRefInstance.value.close()
		}).catch(err => {
			console.log(err)
			ragRefInstance.value.close()
		})
	}

	function GetDynamicValue(item, prefix, suffix) {
		const key = `${prefix}_${suffix}`;
		return item[key];
	}
</script>

<style scoped lang="scss">
	.wearth {
		height: 460px;
		width: 660px;
	}


	.mid_left_table_nav {
		height: 400px;
		width: 600px;
		border: #007e62 1px solid;
		margin: 0 auto;

		.mid_left_table_not {
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* 上下居中 */
			align-items: center;
			/* 左右居中 */
			text-align: center;
			/* 文字居中 */
			height: 100%;
			/* 设置高度为父容器的高度 */
			color: #007e62;
			font-size: 18px;
		}

	}

	.mid_left_table {
		width: 600px;
		border-collapse: collapse;

		background-color: #02372d;
		text-align: center;
		margin: 0 auto;


		th {
			border: 1px solid #007e62;
			height: 20px;
			padding: 8px;
			color: #22caa5;
		}


		td {
			height: 20px;
			padding: 8px;
			border: 1px solid #007e62;
			color: white;

		}
	}

	.pagination {
		width: 100%;

		.el-pagination {
			width: 100%;
			margin-left: 120px;
			margin-top: 20px;

			:deep(.btn-prev),
			:deep(.btn-next) {
				border: 1px solid #007e62;
				background-color: transparent;
				width: 20px;
				height: 20px;
				margin-right: 5px;
			}

			:deep(.el-icon-arrow-left:before,
				.el-icon-arrow-right:before) {
				color: #d5bfa1;
				font-size: 14px;
			}
		}

		:deep(.el-pagination.is-background .el-pager li) {
			border: 1px solid #007e62;
			background-color: transparent;
			color: #007e62;
			width: 20px;
			height: 20px;
			line-height: 20px;
			font-size: 14px;
			margin-right: 5px;
		}

		:deep(.el-pagination.is-background .el-pager li:active) {

			background-color: #007e62;
			color: #007e62;

		}

	}
</style>